import React from "react";
import { Card } from "../../../components/ds";
import ChartSkeleton from "../../../components/OrgAdminGraph/ChartSkeleton";
import SpiderChart from "../../../components/OrgAdminGraph/SpiderChart";
import BarGraph from "../../../components/OrgAdminGraph/BarGraph";
import StackedColumn from "../../../components/OrgAdminGraph/StackedColumn";

const CRRDashboard = ({
  employeeDashboardData,
  crrGraphData,
  milMasterData,
  selectedSurvey = "",
  isAdmin = false,
  loading = false,
}) => {
  const domainList = employeeDashboardData && employeeDashboardData.domains;
  const hasData = domainList?.length > 0;

  // Reserve the analytics height while the per-survey data loads, so the region
  // does not grow from nothing to full charts when data arrives (jump #2). Only
  // when there is no data *and* nothing is loading do we render the empty state.
  if (loading && !hasData) {
    return (
      <>
        <Card className="dashboard-graph-container">
          <div className="radar">
            <ChartSkeleton variant="radar" legend={false} />
          </div>
        </Card>
        <Card>
          <div className="crr-results">
            <ChartSkeleton variant="bars" legend={false} />
          </div>
        </Card>
        <div className="performace-summary-container">
          <ChartSkeleton variant="stack" legend={false} />
        </div>
      </>
    );
  }

  if (!hasData) return null;

  return (
    <>
      <Card className="dashboard-graph-container">
        <div className="radar">
          <SpiderChart domains={domainList} />
        </div>
      </Card>
      <Card>
        <div className="crr-results">
          <BarGraph
            domains={domainList}
            graphData={crrGraphData && crrGraphData[0]?.mil_data}
            masterData={milMasterData}
          />
        </div>
      </Card>
      <div className="performace-summary-container">
        <StackedColumn
          domains={domainList}
          selectedSurvey={selectedSurvey}
          isAdmin={isAdmin}
        />
      </div>
    </>
  );
};

export default CRRDashboard;
